import { action } from 'mobx';

import { AppManager, Variables } from 'core/index';

import { ProjectConnManager } from 'apps/project/connManager';
import { FeaturedProjectsQuery } from 'apps/home/featured/gql';

export class FeaturedProjectsManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.variables = new Variables({
      featuredProjectsCursor: () => null,
      featuredProjectsSortBy: () => this.featuredProjectsConn.sortBy,
      featuredProjectsCount: () => 12,
    });
    this.featuredProjectsConn = new ProjectConnManager(this, {
      initialBatchSize: 12,
      batchSize: 12,
      contains: ['featured_in', 'featured_projects'],
      loadMoreQuery: FeaturedProjectsQuery,
    });

    this.FeaturedProjectsQuery();
  }

  @action FeaturedProjectsQuery = () => {
    this.featuredProjectsConn.loadMore();
  };
}
